import React from 'react';
import { Row, Col, Spin } from 'antd';

//style
import { header } from '../../../../platform/shared/globalStyling/style';

const PaymentInfo = ({ orgData, paymentInfo, loading }) => {
  if (loading) {
    return (
      <Row type="flex" justify="center" align="middle">
        <Spin size="large" />
      </Row>
    );
  } else {
    return (
      <Row type="flex">
        {paymentInfo && paymentInfo.length !== 0 ? (
          <Col span={24}>
            <div style={header}>Card Last 4 Digits: {paymentInfo[0].last4}</div>

            <div style={header}>
              Expiration: {paymentInfo[0].expMonth}/{paymentInfo[0].expYear}
            </div>
          </Col>
        ) : null}
      </Row>
    );
  }
};
export default PaymentInfo;
